import React, {memo} from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import PageTitle from '../PageTitle/PageTitle';

function HeadTools({hideBreadCrumbs, breadCrumbs, title, titleRightComponent}) {
  return (
    <div className="app-content_tools">
      {!hideBreadCrumbs && (
        <BreadCrumbs data={breadCrumbs} />
      )}
      {title && (
        <PageTitle
          title={title}
          rightComponent={titleRightComponent}
        />
      )}
    </div>
  );
}

HeadTools.propTypes = {

};

export default memo(HeadTools);
